/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import delegateIcon from '../../assets/delegateIcon.png';
import { Delegate } from '../../features/delegate/Delegate';
import { useGetDelegateHistoryQuery } from '../../features/delegate/delegateSlice';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import networkToastService from '../networkStatus/networkToastService';
import './delegateToast.scss';

export const DelegateToast = () => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [delegateModal, setDelegateModal] = useState(false);

    const { data: delegationdata, isFetching: delegationDataFetching } = useGetDelegateHistoryQuery(
        {
            employeenumber: loggedEmpNum,
            isDelegateTo: false,
        },
        { skip: !loggedEmpNum }
    );

    const dialogFuncMap = {
        delegateModal: setDelegateModal,
    };

    const onDelegateHide = () => {
        dialogFuncMap.delegateModal(false);
    };

    useEffect(() => {
        if (delegationdata?.data.length > 0) {
            networkToastService.showDelegate(() => setDelegateModal(true));
        } else {
            networkToastService.hideDelegate();
        }
    }, [delegationdata]);

    useEffect(() => {
        if (delegationDataFetching) {
            networkToastService.hideDelegate();
        }
    }, [delegationDataFetching]);

    const delegateHeader = () => (
        <h5 className="mb-3" style={{ fontSize: '24px' }}>
            <img src={delegateIcon} alt="Delegate" className="pe-2" /> Delegate
        </h5>
    );

    return (
        <Dialog
            visible={delegateModal}
            onHide={() => onDelegateHide()}
            className="w-50"
            header={delegateHeader}
        >
            <Delegate index={1} />
        </Dialog>
    );
};
